import { render, staticRenderFns } from "./TipForDriver.vue?vue&type=template&id=e85c35b8"
import script from "./TipForDriver.vue?vue&type=script&lang=js"
export * from "./TipForDriver.vue?vue&type=script&lang=js"
import style0 from "./TipForDriver.vue?vue&type=style&index=0&id=e85c35b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports